var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("Términos y condiciones"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Reglas generales"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Nuestro sitio web está restringido únicamente a personas mayores de edad según lo determinado en la jurisdicción en la que reside el individuo."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Nuestro sitio web no se hace responsable de ninguna ley nacional, federal o internacional infringida por cualquier usuario que utilice nuestro sitio web."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Los usuarios son responsables de sus propias acciones y están sujetos a las leyes de sus propios países, lo que incluye leyes estatales o cuestiones legales."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Todos los agentes son responsables de las cuentas de sus respectivos miembros y deberán respetar todas las apuestas confirmadas enviadas por ellos."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Los agentes no son socios de nuestro sitio web. Por lo tanto, nuestro sitio web no se responsabiliza de ninguna discrepancia o disputa entre jugadores y agentes."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Es responsabilidad del usuario proteger su ID de usuario y contraseña contra usos no autorizados. Si su ID de usuario y contraseña son robados o se ven comprometidos, es su responsabilidad contactar a su agente de inmediato. Este cambiará su ID de usuario y contraseña."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "En caso de robo de ID de usuario y contraseña, el usuario será responsable de su respectiva cuenta y honrará todas las apuestas confirmadas enviadas."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Reglas del juego"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Los resultados del juego decididos por nuestro sitio web serán definitivos y vinculantes."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "En caso de disputa, tanto la administración de nuestro sitio web como el jugador deben aceptar que la base de datos del registro de transacciones de nuestro sitio web actuará como árbitro final. Todas las disputas deben presentarse dentro del día en que se determine el resultado del partido. No se aceptarán reclamaciones después del día del partido."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "El Jugador es el único responsable de verificar la exactitud de todas las transacciones de su cuenta."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Por favor, revise sus apuestas para detectar cualquier error u omisión antes de enviarlas por computadora. Una vez aceptada, no se puede cambiar ni cancelar."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Nos reservamos el derecho de congelar o cancelar la cuenta de cualquier cliente que infrinja estos Términos y Condiciones, participe en actividades fraudulentas, invada, ataque, falsifique, corrompa las reglas estándar o participe en apuestas sindicales, y todos los saldos de cuenta resultantes se congelarán y perderán sin previo aviso."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Nos reservamos el derecho de anular o cancelar cualquier apuesta o boleto que se determine que está relacionado con apuestas sindicadas, apuestas coordinadas, colusión, fraude, abuso del sistema, explotación de errores técnicos, cuotas incorrectas o cualquier otro intento de obtener una ventaja injusta. Las ganancias relacionadas podrán ser anuladas, y la cuenta correspondiente podrá ser suspendida o cerrada."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Límites y responsabilidades"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Sin perjuicio de la generalidad de lo anterior, Nuestro sitio web no será responsable ante ninguna persona en caso de sabotaje, fuerza mayor y/o por los eventos de falla o daño o destrucción del sistema informático central de Nuestro sitio web o registros o cualquier parte del mismo, o demoras, pérdidas, errores, omisiones o cualquier otro de los mismos que resulten de fallas en cualquier sistema de telecomunicaciones o de transmisión de datos, o cualquier demora que resulte en la no recepción de cualquier inscripción para una carrera en particular."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Nuestro sitio web no será responsable de ninguna pérdida como resultado de un acto de Dios, en un brote de hostilidades, disturbios, disturbios civiles, acto de terrorismo, acto de gobierno o autoridad (incluida la denegación o revocación de cualquier licencia o consentimiento), incendio, explosión, inundación, robo, daño malicioso, huelga, cierre patronal y acción industrial de cualquier tipo."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "En caso de errores de red, comunicación, sistema o humanos que causen problemas relacionados con las apuestas, como la aceptación de apuestas dobles, la imposibilidad de confirmar apuestas o la realización de apuestas después del inicio del partido, nos reservamos el derecho, en caso de que se produzcan, de abordarlos caso por caso y de tomar cualquier otra medida para corregirlos. No seremos responsables ante usted ni ante terceros por dichos errores. Si ha experimentado estos errores y continúa apostando sin informar a su equipo, será responsable y asumirá todos los resultados de las ganancias o pérdidas si los errores se repiten."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Estas Reglas y Reglamentos constituyen el acuerdo y entendimiento completo entre las partes."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Si existe alguna discrepancia entre la versión en inglés de estas Reglas y Reglamentos y cualquier versión en otro idioma, la versión en inglés reemplaza a las demás y se considera correcta y válida."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }